export const fileTypes = {
  pdf: 'application/pdf',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  zip: 'application/zip',
  dwg: 'application/acad', // TODO: have to verify
  dxf: 'application/dxf', // TODO: have to verify
};

export const CADFileExtensions = ['dwg', 'dxf'];

export const zipFileTypes = [
  'application/zip',
  'application/x-compressed',
  'application/x-zip-compressed',
  'multipart/x-zip',
  'application/x-7z-compressed',
];

const videoExtensions = [
  'mp4',
  'mov',
  'wmv',
  'avi',
  'flv',
  'mpeg',
  'mpg',
  'm4v',
  '3gp',
  'mkv',
];

export const imageExtensions = ['jpeg', 'jpg', 'png'];
export const pdfExtensions = ['pdf'];
export const allowedMultiUploadExtensions = [
  ...videoExtensions,
  ...imageExtensions,
  ...pdfExtensions,
];
